import { render } from "./SectionShipping.vue?vue&type=template&id=eaa80c46"
import script from "./SectionShipping.vue?vue&type=script&lang=js"
export * from "./SectionShipping.vue?vue&type=script&lang=js"
script.render = render

export default script